import { UsePromptReview } from "./types";

const usePromptReview: UsePromptReview = (trigger) => {};
export default usePromptReview;
